import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Jeff only: whose Potential list to look at.
export const PotentialOwnerPicker = ({ value, onChange, myId, label = "Potential" }) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/users/names").then((r) => setUsers(r.data.filter((u) => u.id !== myId)))
      .catch((e) => console.error("load users", e));
  }, [myId]);
  return (
    <Select value={value || "mine"} onValueChange={(v) => onChange(v === "mine" ? "" : v)}>
      <SelectTrigger className="w-60 rounded-full bg-white" data-testid="potential-owner-picker"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="mine" data-testid="potential-owner-mine">My {label}</SelectItem>
        <SelectItem value="all" data-testid="potential-owner-all">Everyone's {label}</SelectItem>
        {users.map((u) => <SelectItem key={u.id} value={u.id} data-testid={`potential-owner-${u.id}`}>{u.name}'s {label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
